import * as React from 'react';
import { Box, GqlStateHandler } from '..';
import { StyledInput } from './StyledInput';
import { FieldProps, ErrorMessage } from 'formik';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { Query } from 'react-apollo';
import { DocumentNode } from 'graphql';
import { Span, Label } from '../../typography';
import { theme } from '../../theme';

type Props = StyledSystemProps &
  FieldProps & {
    name: string;
    placeholder?: string;
    onSelect?: (data: any) => void;
    onChange: (e: React.FormEvent<any>) => void;
    onSubmit: ({ cellNumber }: { cellNumber: string }) => void;
    query: DocumentNode;
    accessor: string;
    filterAccessors?: string[];
    secondAccessor?: string;
    renderSuggestion: (suggestion: any, color: string) => React.ReactNode;
    onSearchCallback?: (text: string) => void;
    order?: string;
    label?: string;
    clearOnBlur?: boolean;
  };

// This is retarded, but this is the only way to make typescript happy :)
// ( ︶︿︶)_╭∩╮ You Typescript
interface StyleProps {
  input: React.CSSProperties;
  optionsOuterContainer: React.CSSProperties;
  optionsInnerContainer: React.CSSProperties;
  option: React.CSSProperties;
}

const styles: StyleProps = {
  input: {
    borderRadius: theme.borderRadius,
    width: '220px',
    paddingLeft: '10px',
    height: '40px',
    boxSizing: 'border-box',
    marginRight: '20px',
  },
  optionsOuterContainer: {
    backgroundColor: theme.colors.white,
    top: '60px',
    position: 'absolute',
    width: '220px',
    overflow: 'hidden',
    zIndex: 1,
    boxShadow: 'rgba(0, 0, 0, 0.5) 0px 0px 5px -2px',
    borderRadius: theme.borderRadius,
    border: theme.border,
  },
  optionsInnerContainer: {
    overflowY: 'scroll',
    width: '237px',
    maxHeight: '220px',
    padding: '5px 0',
  },
  option: {
    borderRadius: theme.borderRadius,
    color: theme.colors.brownGrey,
    marginRight: '2px',
  },
};

const StyledAutoComplete: React.FC<Props> = (props) => {
  const [showItems, setShowItems] = React.useState<boolean>(false);
  const [suggestionData, setSuggestionData] = React.useState([]);
  const [hoverIndex, setHoverIndex] = React.useState(-1);
  const {
    field,
    query,
    accessor,
    filterAccessors,
    renderSuggestion,
    order,
    label,
    onSubmit,
    placeholder,
    clearOnBlur,
    form,
  } = props;

  const handleCompleted = (data: any): any => {
    if (suggestionData.length === 0) {
      setSuggestionData(data);
    }
  };

  return (
    <Query query={query} variables={{ order }} onCompleted={(data): any => handleCompleted(data[accessor])}>
      {({ data, error }): any => {
        return (
          <GqlStateHandler error={error}>
            {data && (
              <Box>
                <Label htmlFor={field.name}>{label}</Label>
                <StyledInput
                  style={styles.input}
                  onFocus={(): any => setShowItems(true)}
                  onBlur={(): any =>
                    setTimeout(() => {
                      setHoverIndex(-1);
                      setShowItems(false);
                    }, 250)
                  }
                  value={field.value}
                  onChange={(e): any => {
                    form.setFieldValue(field.name, e.target.value);
                  }}
                  placeholder={placeholder}
                />
                {showItems && (
                  <div style={styles.optionsOuterContainer}>
                    <div style={styles.optionsInnerContainer}>
                      {suggestionData &&
                        suggestionData.length > 0 &&
                        suggestionData
                          .filter((item) =>
                            (filterAccessors || [])
                              .map((key: any) => item[key])
                              .some((i: any) => i.toLowerCase().includes((field.value || '').toLowerCase()))
                          )
                          .map((item, index) => {
                            const styleOptions: React.CSSProperties = {
                              backgroundColor: hoverIndex === index ? theme.colors.putty : '',
                            };
                            return (
                              <div
                                onClick={(): any => {
                                  console.log('Helloooooooo', item);
                                  onSubmit(item);
                                  if (clearOnBlur) {
                                    setTimeout(() => form.setFieldValue(field.name, ''), 100);
                                  }
                                }}
                                onMouseOver={(): any => setHoverIndex(index)}
                                style={{ ...styles.option, ...styleOptions }}
                                key={index}
                              >
                                {renderSuggestion(item, hoverIndex === index ? theme.colors.white : '')}
                              </div>
                            );
                          })}
                    </div>
                  </div>
                )}
                <ErrorMessage name={field.name}>
                  {(msg): any => (
                    <Span mt={2} mr={4} color="error" textAlign="right">
                      {msg}
                    </Span>
                  )}
                </ErrorMessage>
              </Box>
            )}
          </GqlStateHandler>
        );
      }}
    </Query>
  );
};

export default StyledAutoComplete;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledAutoComplete.tsx